module.exports = __webpack_public_path__ + "static/media/rcclogo.25e11e06.png";